import { render, staticRenderFns } from "./dashboard-statistics-card.vue?vue&type=template&id=30176eb1"
import script from "./dashboard-statistics-card.vue?vue&type=script&lang=js"
export * from "./dashboard-statistics-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports